import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  DEFAULT_SORT_ORDER,
  PROJECT_DEFAULT_SORT_COLUMN,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface ProjectGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  projectId: number;
  isTokyo: boolean;
  isDairen: boolean;
}

export const DefaultProjectGetQueryParams: ProjectGetQueryParams = {
  page: DEFAULT_PAGE,
  sortOrder: DEFAULT_SORT_ORDER,
  sortKey: PROJECT_DEFAULT_SORT_COLUMN,
  projectId: 0,
  isTokyo: true,
  isDairen: true,
};
